import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  Button,
  makeStyles,
} from "@material-ui/core";
import { Select } from "@ofqual/portal-components/components/Select";
import React, { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { DatePicker } from "@ofqual/portal-components/components/DatePicker";
import { DateEvent } from "../../../../domain/DateEvent";
import { ActionDialogProps } from "./DialogProps";
import { Error } from "../../../common/Error";
import { TextField } from "@ofqual/portal-components/components/TextField";
import { dateTypeService } from "../../../../services";
import { useLookup } from "@ofqual/portal-core/core/hooks";
import { sendDate } from "../../../../redux/actions";

const useStyles = makeStyles((theme) => ({
  changeDetails: {
    padding: 15,
  },
  actions: {
    padding: 15,
  },
  disabledLink: {
    color: "inherit",
    textDecoration: "none",
  },
}));

export const defaultValues: Partial<DateEvent> = {
  note: null,
  date: null,
  dateType: null,
};

export const DateDialog: React.FC<ActionDialogProps> = ({
  application,
  onClose,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [isSaveInProgress, setIsSaveInProgress] = useState<boolean>(false);

  const { handleSubmit, control, errors } = useForm<DateEvent>({
    defaultValues,
  });

  const onSubmit = (newEvent: DateEvent) => {
    setIsSaveInProgress(true);

    dispatch(
      sendDate(application.organisationID.toString(), application.id, newEvent)
    );
    onClose();
  };

  const [dateTypeLookups] = useLookup(dateTypeService);

  return (
    <Dialog
      open={true}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      data-test="add-date-dialog"
    >
      <DialogTitle data-test="add-date-title">
        Add a Date
        <Divider />
      </DialogTitle>

      <DialogContent>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className={classes.changeDetails}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Controller
                  control={control}
                  rules={{ required: true }}
                  name="date"
                  as={
                    <DatePicker
                      dataTest="add-event-date"
                      label="Date of event"
                      required
                    />
                  }
                />
                {errors.date && <Error>This field is required</Error>}
              </Grid>
              <Grid item md={12}>
                <Controller
                  control={control}
                  name="dateType"
                  rules={{ required: true }}
                  as={
                    <Select label="Date type" datatest="date-type" required>
                      {dateTypeLookups}
                    </Select>
                  }
                />
                {errors.dateType && <Error>This field is required</Error>}
              </Grid>

              <Grid item xs={12}>
                <Controller
                  control={control}
                  name="note"
                  rules={{ required: true }}
                  as={
                    <TextField
                      data-test="note"
                      multiline
                      rows={5}
                      label="Note"
                      required
                    />
                  }
                />
                {errors.note && <Error>This field is required</Error>}
              </Grid>
            </Grid>
          </div>
        </form>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <Button
          onClick={onClose}
          data-test="cancel-date-button"
          color="primary"
        >
          Close
        </Button>

        <Button
          onClick={handleSubmit(onSubmit)}
          data-test="add-date-button"
          className={isSaveInProgress ? classes.disabledLink : undefined}
          disabled={isSaveInProgress}
          color="primary"
        >
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};
